module.exports = __webpack_public_path__ + "static/media/profile.76a35b2e.jpg";